"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-five/sections/startNewsSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type StartNewsSection6412sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/blog/blog-38.jpg" | "/Templates/Doccure/img/blog/blog-39.jpg" | "/Templates/Doccure/img/blog/blog-40.jpg" */
    src: string;
    /** Detected variants: "Hearing Health" | "Allergy Care" | "Advanced Treatments" */
    link1Text: ReactNode;
    /** Detected variants: "Dental Myths vs Facts: What You Need to Know" | "How Seasonal Allergies Can Affect Your Nose, Sinuses" | "Reasons Your Child Frequently Gets Ear Infections" */
    link0Text: ReactNode;
    /** Detected variants: "Learn the early symptoms of ear, nose, and throat issues that require timely medical attention." | "A simple guide to understanding seasonal allergies and effective ways to manage them." */
    p0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/patients/patient14.jpg" | "/Templates/Doccure/img/patients/patient1.jpg" | "/Templates/Doccure/img/patients/patient2.jpg" */
    imageWithBasePath0Src: string;
    /** Detected variants: "Dr. Ruby Perrin" | "Daniel Scott" | "Jacob Allen" */
    span0Text: ReactNode;
    /** Detected variants: "col-md-6 col-lg-4 col-sm-12" */
    className?: string;
    /** Detected variants: "news-item-five" */
    div0ClassName?: string;
    /** Detected variants: "news-image" */
    div0ClassName2?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "Post Image" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "badge bg-primary" */
    link1ClassName?: string;
    /** Detected variants: "#" */
    link1Href?: string;
    /** Detected variants: "news-details" */
    div1ClassName?: string;
    /** Detected variants: "news-content" */
    div0ClassName3?: string;
    /** Detected variants: "custom-title line-clamp-2" */
    h30ClassName?: string;
    /** Detected variants: "#" */
    link0Href?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "news-footer" */
    div1ClassName2?: string;
    /** Detected variants: "author" */
    div0ClassName4?: string;
    /** Detected variants: "author-name" */
    link0ClassName?: string;
    /** Detected variants: "all_routes.doctorProfile1" */
    link0Href2?: string;
    /** Detected variants: "Post Author" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "author-img" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "btn btn-secondary" */
    link0ClassName2?: string;
    /** Detected variants: "#" */
    link0Href3?: string;
    /** Detected variants: "isax isax-arrow-right-1" */
    i0ClassName?: string;
};
export type HomeFiveStartNewsSectionGeneratedProps = {
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: StartNewsSection6412sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: StartNewsSection6412sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: StartNewsSection6412sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: StartNewsSection6412sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1Div0H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: StartNewsSection6412sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: StartNewsSection6412sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1Div1Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: StartNewsSection6412sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: StartNewsSection6412sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "LATEST NEWS" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "icon" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/title-icon1.svg" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Latest Trends & Insights" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "Modern Technology." */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "" */
    sectionDiv0Div0Link0LinkDataFancybox?: string;
    /** Default: "Play Video · Play Video ·" */
    sectionDiv0Div0Link0LinkDataText?: string;
    /** Default: "#" */
    sectionDiv0Div0Link0LinkHref?: string;
    /** Default: "Play Video" */
    sectionDiv0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    sectionDiv0Div1ClassName?: string;
    startNewsSection6412s: StartNewsSection6412sItem[];
    startNewsSection6412sItemWrapper?: (item: StartNewsSection6412sItem, content: ReactNode) => ReactNode;
    startNewsSection6412sRenderer?: (defaultNode: ReactNode) => ReactNode;
    startNewsSection6412sLinkVisible?: boolean;
    startNewsSection6412sLinkRenderer?: (item: StartNewsSection6412sItem, defaultNode: ReactNode) => ReactNode;
    startNewsSection6412sImageVisible?: boolean;
    startNewsSection6412sImageRenderer?: (item: StartNewsSection6412sItem, defaultNode: ReactNode) => ReactNode;
    startNewsSection6412sH3Visible?: boolean;
    startNewsSection6412sH3Renderer?: (item: StartNewsSection6412sItem, defaultNode: ReactNode) => ReactNode;
    startNewsSection6412sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: StartNewsSection6412sItem) => Partial<ComponentProps<typeof SmartLink>>);
    startNewsSection6412sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: StartNewsSection6412sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    startNewsSection6412sH3Props?: Partial<ComponentProps<"h3">> | ((item: StartNewsSection6412sItem) => Partial<ComponentProps<"h3">>);
};

const HomeFiveStartNewsSectionGenerated: FC<HomeFiveStartNewsSectionGeneratedProps> = ({
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    sectionDiv0Div0Div0DivText = "LATEST NEWS",
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/title-icon1.svg",
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0H20H2Text = "Latest Trends & Insights",
    sectionDiv0Div0H20H2Text2 = "Modern Technology.",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0Link0LinkDataFancybox = "",
    sectionDiv0Div0Link0LinkDataText = "Play Video · Play Video ·",
    sectionDiv0Div0Link0LinkHref = "#",
    sectionDiv0Div0Link0LinkText = "Play Video",
    sectionDiv0Div0Link0LinkVisible,
    sectionDiv0Div0Link0LinkRenderer,
    sectionDiv0Div0Link0LinkProps,
    divDiv0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div0Link1LinkProps,
    divDiv0Div1Div0H30H3Props,
    divDiv0Div1Div0H30Link0LinkProps,
    divDiv0Div1Div1Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div1Div1Div0Link0LinkProps,
    divDiv0Div1Div1Link0LinkProps,
    sectionDiv0Div1ClassName,
    startNewsSection6412s,
    startNewsSection6412sItemWrapper,
    startNewsSection6412sRenderer,
    startNewsSection6412sLinkVisible,
    startNewsSection6412sLinkRenderer,
    startNewsSection6412sImageVisible,
    startNewsSection6412sImageRenderer,
    startNewsSection6412sH3Visible,
    startNewsSection6412sH3Renderer,
    startNewsSection6412sLinkProps,
    startNewsSection6412sImageProps,
    startNewsSection6412sH3Props,
}) => {
    return (
        <>
            <section className="news-section-five section">
                <div className="container">
                    <div className="section-header section-header-five text-center">
                        <div className="section-sub-title">
                            {" "}
                            {renderNode(sectionDiv0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {sectionDiv0Div0Div0DivText}
                        </div>
                        {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                            <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                        ))}
                    </div>
                    <div className={sectionDiv0Div1ClassName ?? "row news-grid-row justify-content-center g-4"}>
                        {renderCollectionNode(
                            startNewsSection6412s,
                            (item: StartNewsSection6412sItem) => (
                                <div className={item.className ?? "col-md-6 col-lg-4 col-sm-12"} key={item.key}>
                                    <div className={item.div0ClassName ?? "news-item-five"}>
                                        <div className={item.div0ClassName2 ?? "news-image"}>
                                            {renderItemNode(startNewsSection6412sLinkVisible, startNewsSection6412sLinkRenderer, item, (
                                                <SmartLink href={item.href ?? "#"} {...(typeof startNewsSection6412sLinkProps === "function" ? startNewsSection6412sLinkProps(item) : (startNewsSection6412sLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                    {renderItemNode(startNewsSection6412sImageVisible, startNewsSection6412sImageRenderer, item, (
                                                        <SmartImage className={item.imageWithBasePath0ClassName ?? "img-fluid"} src={item.src} alt={item.alt ?? "Post Image"} {...(typeof startNewsSection6412sImageProps === "function" ? startNewsSection6412sImageProps(item) : (startNewsSection6412sImageProps ?? {}))} {...(typeof divDiv0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                </SmartLink>
                                            ))}
                                            {renderItemNode(startNewsSection6412sLinkVisible, startNewsSection6412sLinkRenderer, item, (
                                                <SmartLink href={item.link1Href ?? "#"} className={item.link1ClassName ?? "badge bg-primary"} {...(typeof startNewsSection6412sLinkProps === "function" ? startNewsSection6412sLinkProps(item) : (startNewsSection6412sLinkProps ?? {}))} {...(typeof divDiv0Div0Link1LinkProps === "function" ? divDiv0Div0Link1LinkProps(item) : (divDiv0Div0Link1LinkProps ?? {}))}>{item.link1Text}</SmartLink>
                                            ))}
                                        </div>
                                        <div className={item.div1ClassName ?? "news-details"}>
                                            <div className={item.div0ClassName3 ?? "news-content"}>
                                                {renderItemNode(startNewsSection6412sH3Visible, startNewsSection6412sH3Renderer, item, (
                                                    <h3 className={item.h30ClassName ?? "custom-title line-clamp-2"} {...(typeof startNewsSection6412sH3Props === "function" ? startNewsSection6412sH3Props(item) : (startNewsSection6412sH3Props ?? {}))} {...(typeof divDiv0Div1Div0H30H3Props === "function" ? divDiv0Div1Div0H30H3Props(item) : (divDiv0Div1Div0H30H3Props ?? {}))}>
                                                        {renderItemNode(startNewsSection6412sLinkVisible, startNewsSection6412sLinkRenderer, item, (
                                                            <SmartLink href={item.link0Href ?? "#"} {...(typeof startNewsSection6412sLinkProps === "function" ? startNewsSection6412sLinkProps(item) : (startNewsSection6412sLinkProps ?? {}))} {...(typeof divDiv0Div1Div0H30Link0LinkProps === "function" ? divDiv0Div1Div0H30Link0LinkProps(item) : (divDiv0Div1Div0H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                        ))}
                                                    </h3>
                                                ))}
                                                <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                            </div>
                                            <div className={item.div1ClassName2 ?? "news-footer"}>
                                                <div className={item.div0ClassName4 ?? "author"}>
                                                    {renderItemNode(startNewsSection6412sLinkVisible, startNewsSection6412sLinkRenderer, item, (
                                                        <SmartLink href={item.link0Href2 ?? "all_routes.doctorProfile1"} className={item.link0ClassName ?? "author-name"} {...(typeof startNewsSection6412sLinkProps === "function" ? startNewsSection6412sLinkProps(item) : (startNewsSection6412sLinkProps ?? {}))} {...(typeof divDiv0Div1Div1Div0Link0LinkProps === "function" ? divDiv0Div1Div1Div0Link0LinkProps(item) : (divDiv0Div1Div1Div0Link0LinkProps ?? {}))}>
                                                            {renderItemNode(startNewsSection6412sImageVisible, startNewsSection6412sImageRenderer, item, (
                                                                <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt ?? "Post Author"} className={item.imageWithBasePath0ClassName2 ?? "author-img"} {...(typeof startNewsSection6412sImageProps === "function" ? startNewsSection6412sImageProps(item) : (startNewsSection6412sImageProps ?? {}))} {...(typeof divDiv0Div1Div1Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div1Div1Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div1Div1Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                            ))}
                                                            <span>{item.span0Text}</span>
                                                        </SmartLink>
                                                    ))}
                                                </div>
                                                {renderItemNode(startNewsSection6412sLinkVisible, startNewsSection6412sLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href3 ?? "#"} className={item.link0ClassName2 ?? "btn btn-secondary"} {...(typeof startNewsSection6412sLinkProps === "function" ? startNewsSection6412sLinkProps(item) : (startNewsSection6412sLinkProps ?? {}))} {...(typeof divDiv0Div1Div1Link0LinkProps === "function" ? divDiv0Div1Div1Link0LinkProps(item) : (divDiv0Div1Div1Link0LinkProps ?? {}))}>
                                                        <i className={item.i0ClassName ?? "isax isax-arrow-right-1"} />
                                                    </SmartLink>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ),
                            startNewsSection6412sItemWrapper,
                            startNewsSection6412sRenderer
                        )}
                    </div>
                </div>
            </section>
            <section className="section video-section-five pt-0">
                <div className="container">
                    <div className="play-vid-content">
                        {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                            <h2 className="title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                                {sectionDiv0Div0H20H2Text}
                                <br />
                                {sectionDiv0Div0H20H2Text2}
                            </h2>
                        ))}
                        {renderNode(sectionDiv0Div0Link0LinkVisible, sectionDiv0Div0Link0LinkRenderer, (
                            <SmartLink data-fancybox={sectionDiv0Div0Link0LinkDataFancybox} href={sectionDiv0Div0Link0LinkHref} className="btn btn-secondary" data-text={sectionDiv0Div0Link0LinkDataText} {...(sectionDiv0Div0Link0LinkProps ?? {})}>
                                <i className="isax isax-play" />
                                {sectionDiv0Div0Link0LinkText}
                            </SmartLink>
                        ))}
                    </div>
                </div>
            </section>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeFiveStartNewsSectionGenerated;
